import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'helpdesk/priority-levels';

export const getPriorityLevelsDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
